module.exports = __webpack_public_path__ + "static/media/bg.f942fd6e.png";